module.exports = __webpack_public_path__ + "static/media/foodndrinks_marina_marker.ba5cb8ce.svg";